import User from "./User";
import { BranchEmployeeAttributes } from "../attributes/branch-employee-attributes";
import { parseDate } from "../common/Hooks";
import BusinessBranch from "./BusinessBranch";
import BaseModel from "./BaseModel";
import { MemberStatus } from "../settings/MemberStatus";

class BranchEmployee extends BaseModel {
  id: number;
  can_recharge: number;
  can_withdraw: number;

  declined_at: Date | null;
  activated_at: Date | null;
  requested_more_at: Date | null;

  employee?: User;
  business_branch?: BusinessBranch;

  constructor(
    id: number,
    can_recharge: number,
    can_withdraw: number,
    declined_at: Date | null,
    activated_at: Date | null,
    requested_more_at: Date | null,
    employee: User,
    business_branch: BusinessBranch,
    created_at: Date | null
  ) {
    super(created_at);

    this.id = id;
    this.can_recharge = can_recharge;
    this.can_withdraw = can_withdraw;
    this.declined_at = declined_at;
    this.activated_at = activated_at;
    this.requested_more_at = requested_more_at;
    this.employee = employee;
    this.business_branch = business_branch;
  }

  static fromJson(json: BranchEmployeeAttributes): BranchEmployee | null {
    if (json === null || json === undefined) {
      return null;
    }

    return new BranchEmployee(
      json.id,
      json.can_recharge,
      json.can_withdraw,
      parseDate(json.declined_at),
      parseDate(json.activated_at),
      parseDate(json.requested_more_at),
      User.fromJson(json.employee),
      BusinessBranch.fromJson(json.business_branch),
      parseDate(json.created_at)
    );
  }

  status = (): MemberStatus => {
    if (this.requested_more_at !== null) {
      return MemberStatus.pending;
    }

    if (this.activated_at !== null) {
      return MemberStatus.approved;
    }

    if (this.declined_at !== null) {
      return MemberStatus.declined;
    }

    return MemberStatus.new;
  };

  role = (): any => {
    return "sharedScreen.branchEmployee";
  };
}

export default BranchEmployee;
